<h1>Albion Online Market Prices</h1>
@if (selectedItem && selectedItem.localizedName) {
  <h2>{{ selectedItem.localizedName }}</h2>
} @else {
  <h2><br /></h2>
}
<div style="margin: 10px 0px">
  <mat-accordion>
    <mat-expansion-panel hideToggle>
      <mat-expansion-panel-header>
        <mat-panel-title> Tutorial </mat-panel-title>
        <mat-panel-description> </mat-panel-description>
      </mat-expansion-panel-header>
      <div style="margin-bottom: 10px">Please watch the following tutorial on how to use the price checker.</div>
      <div style="display: flex; justify-content: center">
        <p>Check the video tutorial on <a href="https://www.youtube.com/watch?v=KGxpzOD9DzE" target="_blank">YouTube</a></p>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
@if (shopCategories && items && !isLoading) {
  <div class="flex-container-column">
    <div class="form-container">
      <button
        class="form-item-button"
        mat-mini-fab
        (click)="refreshPrices()"
        [disabled]="(!(this.prices$ | async) && !(this.histories$ | async)) || disableRefresh"
        color="primary"
        aria-label="Clear All Button"
        matTooltip="Refresh Prices"
      >
        <mat-icon>refresh</mat-icon>
      </button>
      <app-item-selector
        class="form-container-inline"
        [shopCategories]="shopCategories"
        [items]="items"
        [showItemSelector]="true"
        [(selectedCategory)]="selectedCategory"
        [(selectedSubCategory)]="selectedSubCategory"
        [(selectedTier)]="selectedTier"
        [(selectedItem)]="selectedItem"
      >
      </app-item-selector>
      <mat-form-field class="form-item-medium" appearance="fill">
        <mat-label>Price Type</mat-label>
        <mat-select [(value)]="userSettingsService.getUserPriceConfig().priceType">
          @for (type of priceTypes; track type) {
            <mat-option [value]="type">
              {{ type.friendlyName }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="form-item-medium">
        <mat-label>Number of Days for Average</mat-label>
        <input matInput [(ngModel)]="userSettingsService.getUserPriceConfig().averageNumberOfDays" type="number" step="1" min="3" max="30" />
      </mat-form-field>
      <mat-form-field class="form-item-medium" appearance="fill">
        <mat-label>Prices to Display</mat-label>
        <mat-select [(value)]="userSettingsService.getUserPriceConfig().priceDisplayOption">
          @for (option of priceDisplayOptions; track $index) {
            <mat-option [value]="option">
              {{ option.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div>
      <button mat-fab extended color="primary" (click)="savePriceConfiguration()" [disabled]="disableSaveConfig" style="margin: 5px 0px">
        <mat-icon>save</mat-icon>
        Save Prices Configuration
      </button>
    </div>
    <app-locations-legend style="margin: 10px 0px"></app-locations-legend>
    <div class="price-card-container">
      @for (item of this.filterItemsToShow(this.items); track $index) {
        <div>
          <app-item-price-card
            [item]="item"
            [prices]="filterPricesForCard(item, prices$ | async)"
            [histories]="histories$ | async"
            [numberOfDaysAverage]="userSettingsService.getUserPriceConfig().averageNumberOfDays"
            [imageUrl]="getItemImageUrl(item)"
            [showQualityLegend]="true"
            [priceType]="userSettingsService.getUserPriceConfig().priceType"
          />
        </div>
      }
    </div>
  </div>
  @if (selectedItem) {
    <div style="margin: 15px 0px">
      <mat-accordion>
        <mat-expansion-panel hideToggle>
          <mat-expansion-panel-header>
            <mat-panel-title> Item Data </mat-panel-title>
            <mat-panel-description> </mat-panel-description>
          </mat-expansion-panel-header>
          <div style="width: 100%; display: flex; flex-wrap: wrap">
            @for (item of this.filterItemsToShow(this.items); track $index) {
              <div style="border: 1px solid; border-radius: 4px; margin: 10px; padding: 10px; background-color: rgba(0, 0, 0, 0.2)">
                <p style="font-weight: 500; text-align: center; margin-bottom: 20px">{{ item.localizedName }}</p>

                <p>{{ item.uniqueName }}</p>

                <mat-divider></mat-divider>

                <p>Tier: {{ item.tier ?? 0 }}</p>

                <p>Enchantment Level: {{ item.enchantmentLevel ?? 0 }}</p>

                @if (jsonReaderService.getShopCategoryLocalizedName(item.shopCategory, userSettingsService.getUserLanguage())) {
                  <p>Shop Category: {{ jsonReaderService.getShopCategoryLocalizedName(item.shopCategory, userSettingsService.getUserLanguage()) }}</p>
                }

                @if (jsonReaderService.getShopSubCategoryLocalizedName(item.shopSubCategory, userSettingsService.getUserLanguage())) {
                  <p>Shop Sub Category: {{ jsonReaderService.getShopSubCategoryLocalizedName(item.shopSubCategory, userSettingsService.getUserLanguage()) }}</p>
                }

                <mat-divider></mat-divider>

                @if (jsonReaderService.getItemValue(item); as value) {
                  <p>Item Value: {{ value | number }}</p>
                  @if (item.durability) {
                    <p>Repair Cost (5%): {{ Math.ceil((value / 7) * 5) | number }}</p>
                  }
                }

                @if (item.durability) {
                  <p>Durability: {{ item.durability | number }}</p>
                }

                @if (item.weight) {
                  <p>Weight: {{ item.weight | number }}</p>
                }

                @if (item.itemPower) {
                  <p>Item Power: {{ item.itemPower | number }}</p>
                }

                @if (item.slotType && item.slotType.printName) {
                  <p>Slot Type: {{ item.slotType.printName }}</p>
                }

                @if (jsonReaderService.getItemCraftFame(item, item.craftingRequirements[0]); as fame) {
                  <mat-divider></mat-divider>
                  <p>Craft Journal Fame: {{ fame | number }}</p>
                  <p>Craft Fame: {{ fame * (item.craftFameFactor ?? 1) | number }}</p>
                  <p>Craft Premium Fame: {{ fame * (item.craftFameFactor ?? 1) * fameBonusPremium | number }}</p>
                }

                @if (item.foodCategory) {
                  <mat-divider></mat-divider>
                  <p>Food Category: {{ item.foodCategory }}</p>
                }

                @if (item.nutrition) {
                  <p>Nutrition: {{ item.nutrition | number }}</p>
                }

                @if (item.farmKind) {
                  <mat-divider></mat-divider>
                  <p>Farming:</p>

                  @if (item.farmPlaceFame) {
                    <p>Place Fame: {{ item.farmPlaceFame | number }}</p>
                  }

                  @if (item.farmKind) {
                    <p>Kind: {{ item.farmKind }}</p>
                  }

                  @if (item.farmActiveFarmFocusCost) {
                    <p>Focus Cost: {{ item.farmActiveFarmFocusCost | number }}</p>
                  }

                  @if (item.farmActiveFarmMaxCycles) {
                    <p>Max Cycles: {{ item.farmActiveFarmMaxCycles | number }}</p>
                  }

                  @if (item.farmActiveFarmActionDurationSeconds) {
                    <p>Action Duration: {{ item.farmActiveFarmActionDurationSeconds | number }} seconds</p>
                  }

                  @if (item.farmActiveFarmCycleLengthSeconds) {
                    <p>Cycle Length: {{ item.farmActiveFarmCycleLengthSeconds | number }} seconds</p>
                  }

                  @if (item.farmActiveFarmBonus) {
                    <p>Bonus: {{ item.farmActiveFarmBonus | number }}</p>
                  }
                }

                @if (item.farmHarvest) {
                  <mat-divider></mat-divider>
                  <p>Harvest:</p>
                  <p>Growth Time: {{ item.farmHarvest.growTime | number }} seconds</p>
                  <p>Fame: {{ item.farmHarvest.fame | number }}</p>
                  <p>Loot Chance: {{ item.farmHarvest.lootChance | percent }}</p>

                  @if (item.farmHarvest.seed) {
                    <p>Seed Return Chance: {{ item.farmHarvest.seed.chance | percent }}</p>
                    <p>Seed Return Amount: {{ item.farmHarvest.seed.amount | number }}</p>
                  }

                  @if (item.farmHarvest.lootList?.lootItems?.length) {
                    <p>Possible Harvests:</p>
                    @for (loot of item.farmHarvest.lootList.lootItems; track loot) {
                      <div style="margin-left: 20px">
                        <p>Type: {{ loot.item?.localizedName }}</p>
                        <p>Chance: {{ loot.chance | number }}</p>
                        <p>Amount: {{ loot.amountMin }}{{ loot.amountMax !== loot.amountMin ? '-' + loot.amountMax : '' }}</p>
                      </div>
                    }
                  }
                }

                @if (item.farmGrownItem) {
                  <mat-divider></mat-divider>
                  <p>Growth:</p>
                  <P>Product: {{ item.farmGrownItem.item?.localizedName }}</P>
                  <p>Time: {{ item.farmGrownItem.growTime | number }} seconds</p>
                  <p>Fame: {{ item.farmGrownItem.fame }}</p>
                  <p>Offspring chance: {{ item.farmGrownItem.offspring.chance | percent }}</p>
                  <p>Offspring amount: {{ item.farmGrownItem.offspring.amount }}</p>
                }

                @if (item.farmConsumption?.food) {
                  <mat-divider></mat-divider>
                  <p>Consumption:</p>
                  <p>Nutrition Max: {{ item.farmConsumption!.food.nutritionMax | number }}</p>
                  <p>Seconds per Nutrition: {{ item.farmConsumption!.food.secondsPerNutrition | number }}</p>
                  @if (item.farmConsumption?.food?.lossBeforeHungry) {
                    <p>Loss Before Hungry: {{ item.farmConsumption!.food.lossBeforeHungry | number }}</p>
                  }
                  <p>Accepted Food:</p>
                  <p>Category: {{ item.farmConsumption!.food.acceptedFood.foodCategory }}</p>
                  @if (item.farmConsumption?.food?.acceptedFood?.favorite) {
                    <p>Favorite: {{ item.farmConsumption!.food.acceptedFood.favoriteItem?.localizedName }}</p>
                  }
                  @if (item.farmConsumption?.food?.acceptedFood?.favoriteBonus) {
                    <p>Favorite Bonus: {{ item.farmConsumption!.food.acceptedFood.favoriteBonus | number }}</p>
                  }
                }

                @if (item.farmProducts) {
                  <mat-divider></mat-divider>
                  <p>Products:</p>
                  <p>Production Time: {{ item.farmProducts.product.productionTime | number }}</p>
                  <p>Loot Chance: {{ item.farmProducts.product.lootChance | percent }}</p>
                  <p>Fame: {{ item.farmProducts.product.fame | number }}</p>

                  @if (item.farmProducts.product.lootList) {
                    <p>Loot List:</p>
                    @for (lootItem of item.farmProducts.product.lootList.lootItems; track lootItem) {
                      <p>- {{ lootItem.item?.localizedName }} ({{ lootItem.amountMin }}-{{ lootItem.amountMax }})</p>
                      <p>- - Chance: {{ lootItem.chance | percent }}</p>
                    }
                  }
                }
              </div>
            }
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  }
} @else {
  <mat-spinner></mat-spinner>
}
